import type * as React from "react";
import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from "#/components/ui/tooltip";
import { cn } from "#/lib/utils";

export function InfoTooltip({
	content,
	children,
	label,
	side = "top",
	className,
}: {
	/** Tooltip body shown on hover/focus. */
	content: React.ReactNode;
	/**
	 * Visible label rendered as the trigger, shown with a dashed underline
	 * (market-info style) to hint that hovering reveals the tooltip.
	 */
	children?: React.ReactNode;
	/** Accessible name for the trigger. Used when there is no visible `children`. */
	label?: string;
	side?: "top" | "right" | "bottom" | "left";
	/** Trigger color/size classes — set per context (portfolio vs trade tokens). */
	className?: string;
}) {
	return (
		<Tooltip>
			<TooltipTrigger asChild>
				<button
					type="button"
					aria-label={children ? undefined : label}
					className={cn(
						"cursor-pointer underline decoration-dashed underline-offset-2 focus-visible:outline-none",
						className,
					)}
				>
					{children}
				</button>
			</TooltipTrigger>
			<TooltipContent side={side}>{content}</TooltipContent>
		</Tooltip>
	);
}
